import getScenarioStore from '../selectors/getScenarioStore';
import SearchScenarioId from '../store/schema/SearchScenarioId';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'setNextSearchQueryId',
    (nextSearchQueryId: string, scenarioId: SearchScenarioId): void => {
        getScenarioStore(scenarioId).nextSearchQueryId = nextSearchQueryId;
    }
);
